export default (isAdded = false) => ({
    isAdded: false,
    byButton: 'Купить',

    init() {
        if (isAdded == true) {
            this.setAdded();
        }
    },

    setAdded() {
        this.isAdded = !this.isAdded
    },

    addCart(offerID) {
        if (this.isAdded) {
            window.location.href = "/checkout/";
            return;
        }

        var cart = [{offer_id: offerID, quantity: 1}];

        const data = {cart};

        this.request('Cart::onAdd', {
            data: data,
            update: { 'common/header/busket': '.js-cart' },
            loading: '.preloader-selector'
        });

        this.setAdded();
    },

    removeCart(offerID) {
        var cart = [{offer_id: offerID}];
        const data = {cart};

        this.request('Cart::onRemove', {
            data: data,
            loading: '.preloader-selector'
        });

        setTimeout(() => {
           window.location.href = "/checkout/";
        }, 200)
    },

    clear() {
        this.request('Cart::onClear', {
            data: [],
            loading: '.preloader-selector'
        });
    },
});